import React from 'react';
import { PaintBrushIcon, DocumentTextIcon, GlobeAltIcon } from '@heroicons/react/24/outline';

export default function FeaturesSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-cleona-50/50 to-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 rounded-pill bg-cleona-600 px-4 py-2 mb-6">
            <span className="text-white font-manrope font-semibold text-sm">Smart Support</span>
            <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
              <svg className="w-3 h-3 text-cleona-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </span>
          </div>
          <h2 className="font-jakarta text-4xl font-bold text-gray-900 sm:text-5xl mb-4">
            Smarter Support, Powered by<br />Your Own Knowledge
          </h2>
          <p className="max-w-2xl mx-auto text-gray-600 font-manrope">
            CLEONA adapts to your content, your brand, and your workflows.<br />
            Give users accurate answers wherever they need them.
          </p>
        </div>

        {/* Features image */}
        <div className="flex justify-center">
          <img
            src="/images/features/smarter-support.png"
            alt="CLEONA Features - Train on Your Resources, Customize and Brand, Embed Anywhere"
            className="w-full max-w-5xl h-auto"
          />
        </div>
      </div>
    </section>
  );
}
